export default __webpack_public_path__ + "static/media/illustration-study-2-n-w@3x.a0a277d3.png";